/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
import * as React from 'react';
import {useEffect, useRef, useState, VFC, useCallback, useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import {Modal} from '@baidu/hcui';
import useRouter, {useSearchParams} from '@/hooks/router';
import share from '@/utils/share';
import {pageHide, pageShow} from '@/utils/dom';
import {ACT_COMMON_LOG_CONFIG} from '@/utils/constant';
import SelfNaviSlideBar from '@/pages/specialDisease/slidebar';
import SelfNaviH from '@/pages/specialDisease/naviH';
import {logClkReport} from '@/utils/ubcUtils';
import {isDoctorApp, isWiseAgent, getQueryObject, stringfyQueryString, addParamsToUrl, getUrlParamValue} from '@/utils/utils';
import useSetPageTitle from '@/hooks/useSetPageTitle';
import {getTopicInfo, getTopicShareInfo, TopicModule, TopicResponseData, TopicShareResponse, TopicItemInfo} from '@/services/pages/channel/channel.client';
import {VALUE_TYPE} from '@/dicts/consts';
import Exposure from '@/utils/exposure';
import {baseSendExposure} from '@/utils/logger/baseSendExposure';
import BrandEntry from '@/components/BrandEntry';
import {WHITE_LIST} from '@/dicts/networkWhiteList';
import DiseaseTopCard from '../topcard';
import {ACTIONS, useDispatchStore, useStateStore} from '../../Store';
import {TopCardImg} from '../../../interfaces/specialDisease';
import {
    SELF_TOPIC_BAR,
    SELF_TOPIC_CONTAINER,
    SELF_TOPIC_CONTAINER_TYPE_H,
    SELF_TOPIC_CONTAINER_TYPE_V,
    SELF_TOPIC_CONTENT_NAME,
    SELF_TOPIC_CONTENT_TYPE_FLOW_BIG,
    SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL,
    SELF_TOPIC_CONTENT_TYPE_HORIZONTAL,
    SELF_TOPIC_HEAD_NAME,
    SELF_TOPIC_IMAGE_NAME,
    SELF_TOPIC_IMAGE_TYPE_BANNER,
    SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_GOLD_ICON,
    SELF_TOPIC_IMAGE_TYPE_HORIZONTAL,
    SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN,
    SELF_TOPIC_NAVI,
    SELF_TOPIC_NAVI_HORIZONTAL,
    SELF_TOPIC_NAVI_VERTICAL,
    SELF_TOPIC_TOFU_CUBE_NAME,
    SELF_TOPIC_TAB_NAME,
    SELF_TOPIC_CONTAINER_TYPE_MIX,
    SELF_TOPIC_EXPERT,
    SELF_TOPIC_IMAGE_TYPE_SWIPER,
    SELF_TOPIC_CONTENT_TYPE_SINGLEABS,
    COMMON_APP_INVOKE,
    COMMON_VOTE,
    SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING,
    SELF_TOPIC_BALL,
    // 图片模块 - value:19 图片大尺寸样式
    SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL,
} from '../../../dicts/modelConsts';
import SelfTopicContentHorizontal from '../hotContent';
import SelfTopicContentFlowSmall from '../../../components/flowSmall';
import SelfTopicTofuText from '../../../components/tofuText';
import SelfTopicImgDoubleColumn from '../../../components/doubleColumn';
import DiseaseGoldIcons from '../goldIcons';
import SelfTopicImageHorizontal from '../../../components/imgHorizontal';
import DiseaseBannerSwipe from '../swiper';
import VideoSwpier from '../videoSwiper';
import SelfTopicContentFlowBig from '../../../components/flowBig';
import SelfTopicContainerHorizontal from '../../../components/containerHorizontal';
import SelfTopicContainerVertical from '../../../components/containerVertical';
import SelfTopicContainerAggregation from '../../../components/SelfTopicContainerAggregation';
import SelfTopicBottomBar from '../../../components/bottomBar';
import SelfTopicImgSpecialDoubleColumn from '../../../components/specialDoubleColumn';
import SelfTopicExpert from '../../../components/selfTopicExpert';
import SelfTopicContentSingleAbstract from '../../../components/common/singleAbstract';
import SeamlessPuzzle from '../../../components/seamlessPuzzle';
import Vote from './vote/vote';
import AppInvoke from './appInvoke/appInvoke';
import styles from './index.less';


interface InfoQuery {
    id?: string;
    sa?: string;
    sf_ch?: string;
    preview?: boolean;
}

const SpecialDisease: VFC = () => {
    // eslint-disable-next-line global-require
    const ua = require('@searchfe/user-agent');
    const [sfRef, setSfRef] = useState<string>();
    const [loadStatus, setLoadStatus] = useState(true);
    const [infoLoadStatus, setInfoLoadStatus] = useState(false); // 接口状态
    const dispatch = useDispatchStore();


    const param = useSearchParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const cblMap = ['', 'zt_yl', 'zt_qd', 'zt_ym', 'zt_syh'];

    // 获取页面底色
    const [pageBgc, setPageBgc] = useState<string>('#f5f5f5');
    const [cbl, setCbl] = useState(0);

    // 获取卡片信息
    const [infoQuery, setInfoQuery] = useState<InfoQuery>();
    // 卡片
    const [topicInfos, setTopicInfos] = useState<TopicResponseData>();

    // 分享信息
    const [shareInfos, setShareInfos] = useState<TopicShareResponse>();

    // 头图
    const [topCardInfo, setTopCardInfo] = useState<TopCardImg>({});

    // 侧边栏
    const [slideBarInfo, setSlideBarInfo] = useState<TopicModule>({});
    const [slideBarStatus, setSlideBarStatus] = useState<boolean>(false);

    // 顶部导航栏
    const [naviBarInfo, setNaviBarInfo] = useState<TopicModule>({});
    const [naviBarStatus, setNaviBarStatus] = useState<boolean>(false);

    const [entryBallInfo, setEntryBallInfo] = useState<TopicModule>();

    const [selectModuleId, setSelectModuleId] = useState<string>();
    const [selectChildModuleId, setChildModuleId] = useState<string>();

    const [channelName, setChannelName] = useState('');
    const [channelId, setChannelId] = useState('');
    useSetPageTitle(channelName);

    // 存储div的id和高度
    const moduleIds = useRef<number[]>([]);

    // 底bar
    const [bottomBarInfo, setBottomBarInfo] = useState<TopicModule>({});

    const navHeight = 192 / 3;

    const height = 201 / 3;

    const mPage = useLocation().pathname;

    // 进入页面时间戳
    let startTime = 0;

    const trackerRef = useRef<Exposure>();
    const handleScroll = () => {
        // 头图滑动到某个位置，横滑导航栏展示
        const top = (document.getElementById('belowTopImgParentId')?.getBoundingClientRect().y || 0);

        // eslint-disable-next-line no-unused-expressions
        topCardInfo?.moduleId && top < navHeight ? setNaviBarStatus(true)
            : topCardInfo?.moduleId && top > navHeight ? setNaviBarStatus(false)
                : null;

        // eslint-disable-next-line no-unused-expressions
        !topCardInfo?.moduleId && top < -navHeight ? setNaviBarStatus(true)
            : !topCardInfo?.moduleId && top > -navHeight ? setNaviBarStatus(false)
                : null;

        moduleIds?.current?.map(
            // eslint-disable-next-line array-callback-return
            moduleId => {
                const boundingClientRect = document.getElementById(moduleId.toString())?.getBoundingClientRect();
                // eslint-disable-next-line no-unused-expressions
                ((boundingClientRect?.top || 0) < height
                    && (boundingClientRect?.top || 0) + (boundingClientRect?.height || 0)
                    > height)
                    ? setSelectModuleId(moduleId.toString())
                    : null;
            }
        );
    };


    const getCusStyle = (moduleItem: TopicModule) => {
        const styleObj = {
            backgroundColor: moduleItem.moduleBgc ? moduleItem.moduleBgc : 'white',
            borderRadius: moduleItem.moduleFillet === 1 ? '0px' : '12px',
            marginRight: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginLeft: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginTop: moduleItem.moduleSpaceBack === 1 ? '0' : '8px',
        };
        return styleObj ?? {};
    };

    const initExposure = useCallback(
        (lists: any) => {
            return lists.some((module: any) => module.moduleEnName === SELF_TOPIC_BAR);
        },
        []
    );

    useEffect(
        () => {
            if (!loadStatus && dispatch && !infoLoadStatus) {
                dispatch({
                    type: ACTIONS.SET_SKELETON_STATUS,
                    payload: loadStatus,
                });
            }
        },
        [loadStatus, infoLoadStatus, dispatch]
    );

    // eslint-disable-next-line camelcase
    const fetchInfo = async (id?: string, sa?: string, sf_ch?: string, preview?: boolean) => {
        if (!id) {
            return;
        }
        try {
            const result = await getTopicInfo({
                // eslint-disable-next-line camelcase
                id: id, sa: sa, preview: preview,
            });

            setLoadStatus(false);
            setInfoLoadStatus(true);
            if (!result) {
                return;
            }
            const hasBottomBar = initExposure(result.moduleList);
            setTimeout(
                () => {
                    trackerRef.current = new Exposure(
                        hasBottomBar
                            ? {rootMargin: '0px 0px -50px 0px'}
                            : {rootMargin: '0px 0px 0px 0px'}
                    );
                },
                1000
            );
            const mIds: number[] = [];
            // 渲染头图
            result.moduleList.map(
                // eslint-disable-next-line complexity
                model => {
                    mIds.push((model.moduleId || 0));
                    const field = model && model.itemList && model.itemList[0].fieldValue;
                    // eslint-disable-next-line no-unused-expressions
                    model.moduleEnName === SELF_TOPIC_HEAD_NAME ? setTopCardInfo({
                        id: infoQuery?.id,
                        // eslint-disable-next-line camelcase
                        sf_ch: infoQuery?.sf_ch,
                        moduleId: model.moduleId,
                        itemId: model.itemList ? model.itemList[0]?.itemId : 0,
                        selfLogo: field?.logo,
                        selfName: field?.selfName,
                        bgImage: field?.bgImage,
                        floatBtnText: field?.floatBtnText,
                        floatBtnUrl: field?.floatBtnUrl,
                        thirdLogo: field?.thirdLogo,
                        thirdName: field?.thirdName,
                        title: field?.title,
                        titleImage: field?.titleImage,
                        readNum: field?.readNum,
                        thirdUrl: field?.thirdUrl,
                        moduleName: model.moduleName,
                    })
                        : model.moduleEnName === SELF_TOPIC_BAR && model.itemList
                            ? setBottomBarInfo(model)
                        // eslint-disable-next-line max-len
                            : model.moduleEnName === SELF_TOPIC_NAVI && model.moduleStyle === SELF_TOPIC_NAVI_VERTICAL && model?.itemList
                                ? setSlideBarInfo(model)
                            // eslint-disable-next-line max-len
                                : model.moduleEnName === SELF_TOPIC_NAVI && model.moduleStyle === SELF_TOPIC_NAVI_HORIZONTAL && model?.itemList
                                    ? setNaviBarInfo(model)
                                    : '';
                    if (model.moduleEnName === SELF_TOPIC_BALL && model.itemList) {
                        setEntryBallInfo(model);
                    }
                }
            );
            setTopicInfos(result);
            setPageBgc(result.pageBgc || '');
            setCbl(result.channelBusinessLine ?? 0);
            setChannelName(result.channelName);
            setChannelId(result.channelId ?? '');

            moduleIds.current.push(...mIds);

            // 整页曝光
            baseSendExposure({
                'page': mPage,
                'value': 'page',
                'pageSourceId': result.channelId ?? '',
                'pageType': cblMap[result.channelBusinessLine],
            });

        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }

    };

    const fetchAuthInfo = async () => {
        try {
            const shareInfo = await getTopicShareInfo({
                wxAppKey: 'netHospitalService',
                url: window.location.href,
            });
            setShareInfos(shareInfo);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    useEffect(
        () => {
            fetchInfo(
                infoQuery?.id,
                infoQuery?.sa,
                infoQuery?.sf_ch,
                infoQuery?.preview
            );
        },
        [infoQuery]
    );

    useEffect(
        () => {
            if (ua.isWeixinApp()) {
                fetchAuthInfo();
            }
            setInfoQuery({
                id: param.id,
                sa: param.sa,
                // eslint-disable-next-line camelcase
                sf_ch: param.sf_ch,
                preview: param.preview,
            });
            setSfRef(param.sf_ref);
            startTime = Date.now();
            pageHide(() => {
                try {
                    if (navigator.sendBeacon) {
                        const qObj = getQueryObject(window.location.href) || {};
                        const endTime = Date.now();
                        const params = {
                            pid: ACT_COMMON_LOG_CONFIG.PID,
                            type: 'disp_module',
                            group: 'health',
                            info: JSON.stringify({
                                mod: 'duration',
                            }),
                            ts: endTime,
                            ext: JSON.stringify({
                                startTime,
                                endTime,
                                query: JSON.stringify(qObj),
                                frsrcid: qObj.frsrcid || '',
                                duration: endTime - startTime,
                                page: 'cec/specialDisease/topic',
                            }),
                        };

                        const URL = `${ACT_COMMON_LOG_CONFIG.url}${stringfyQueryString(params)}`;
                        navigator.sendBeacon(URL);
                    }
                }
                catch (e) {
                    // eslint-disable-next-line no-console
                    console.log(e);
                }
            });
            pageShow(() => {
                startTime = Date.now();
            });
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        },
        []
    );

    useEffect(
        () => {
            if (ua.isWeixinApp() && topicInfos && shareInfos) {
                share({
                    title: topicInfos?.channelShareTitle,
                    content: topicInfos?.channelShareSubTitle,
                    imageUrl: topicInfos?.channelShareLogo,
                    url: shareInfos?.url,
                }, {
                    debug: false,
                    appId: shareInfos?.appId ?? '',
                    timestamp: shareInfos?.timestamp ?? '',
                    nonceStr: shareInfos?.nonceStr ?? '',
                    signature: shareInfos?.signature ?? '',
                });
            } else {
                share({
                    title: topicInfos?.channelShareTitle,
                    content: topicInfos?.channelShareSubTitle,
                    imageUrl: topicInfos?.channelShareLogo,
                    url: shareInfos?.url,
                });
            }
        },
        [topicInfos, shareInfos, ua]
    );

    const {dialogModuleId} = useStateStore();
    const router = useRouter();

    const addParams = useMemo(
        () => {
            const params: {[key: string]: string} = {};
            // eslint-disable-next-line array-callback-return
            Object.keys(router?.query).map(item => {
                WHITE_LIST.includes(item) && (params[item] = router?.query?.[item] as string || '');
            });
            return params;
        },
        [router?.query]
    );

    useEffect(
        () => {
            // 弹窗模块的moduleEnName：selfPopup
            const dialogDataList = topicInfos?.moduleList?.find(
                (list: TopicModule) => list?.moduleEnName === 'selfPopup'
            );

            const popupMsg = dialogDataList?.itemList?.find(
                (list: TopicItemInfo) => list?.itemId === dialogModuleId
            );

            const urlParams = {
                from: getUrlParamValue(window.location.href, 'from'),
                // eslint-disable-next-line camelcase
                sf_ref: getUrlParamValue(window.location.href, 'sf_ref'),
                // eslint-disable-next-line camelcase
                sf_ch: getUrlParamValue(window.location.href, 'sf_ch'),
                ...addParams,
            };

            if (popupMsg && popupMsg.fieldValue) {
                const dialogText = popupMsg.fieldValue?.content || '温馨提示';
                const dialogTitle = popupMsg.fieldValue?.title || '您是否要离开此页面';
                const dialogJumpText = popupMsg.fieldValue?.desc || '确认前往';
                const swanUrl = (popupMsg.fieldValue?.swanUrl && addParamsToUrl(popupMsg.fieldValue?.swanUrl, urlParams)) || '';
                const h5Link = (popupMsg.fieldValue?.link && addParamsToUrl(popupMsg.fieldValue?.link, urlParams)) || '';
                const isBdBox = navigator.userAgent.includes('baiduboxapp');
                Modal.confirm({
                    title: dialogTitle,
                    content: dialogText,
                    cancelText: '取消',
                    okText: dialogJumpText,
                    onOk: () => {
                        window.location.href = isBdBox && swanUrl ? swanUrl : h5Link;
                        logClkReport(
                            mPage,
                            'jump_tanchuang',
                            popupMsg.channelId,
                            cblMap[cbl],
                            popupMsg.moduleId,
                            'selfPopup',
                            {
                                // eslint-disable-next-line camelcase
                                value_type: VALUE_TYPE.ITEM,
                                // eslint-disable-next-line camelcase
                                value_id: popupMsg.itemId,
                                // eslint-disable-next-line camelcase
                                value_title: dialogJumpText,
                            }
                        );
                    },
                    onCancel: () => {
                        logClkReport(
                            mPage,
                            'jump_tanchuang',
                            popupMsg.channelId,
                            cblMap[cbl],
                            popupMsg.moduleId,
                            'selfPopup',
                            {
                                // eslint-disable-next-line camelcase
                                value_type: VALUE_TYPE.ITEM,
                                // eslint-disable-next-line camelcase
                                value_id: popupMsg.itemId,
                                // eslint-disable-next-line camelcase
                                value_title: '取消',
                            }
                        );
                    },
                });
                // 整体弹窗展现
                baseSendExposure({
                    'page': mPage,
                    'value': 'tanchuang',
                    'pageSourceId': popupMsg.channelId,
                    'pageType': cblMap[cbl],
                    'valueId': popupMsg.moduleId,
                    'valueTitle': 'selfPopup',
                    'valueType': VALUE_TYPE.MODULE,
                });
            }
            // hooks/useJumpUrl中向上dispatch值，此处恢复默认值
            dispatch?.({
                type: ACTIONS.SET_DIALOG_STATUS,
                payload: 0,
            });
        },
        [dialogModuleId, topicInfos, dispatch]
    );

    // 渲染
    const renderInfo = React.useCallback(
        () => {
            return (
                <div>
                    {
                        topicInfos?.moduleList.map(
                            // eslint-disable-next-line complexity
                            model => {
                                switch (model.moduleEnName) {
                                    case SELF_TOPIC_IMAGE_NAME:
                                        switch (model.moduleStyle) {
                                            case SELF_TOPIC_IMAGE_TYPE_BANNER:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                key={model.moduleId}
                                                                // eslint-disable-next-line max-len
                                                                className={(model.isShowTitle === 1 && (model.moduleName || model.moduleSubTitle))
                                                                    ? styles.cardBg : styles.cardBottomBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <DiseaseBannerSwipe
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    bannersModel={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_HORIZONTAL:
                                            case SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                key={model.moduleId}
                                                                className={styles.cardImgHBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicImageHorizontal
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_GOLD_ICON:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <DiseaseGoldIcons
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    goldIcons={{
                                                                        channelId: model.channelId,
                                                                        moduleId: model.moduleId,
                                                                        golds: model.itemList,
                                                                        moduleMaxColumns: model.moduleMaxColumns,
                                                                        moduleName: model.moduleName,
                                                                    }
                                                                    }
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicImgDoubleColumn
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicImgSpecialDoubleColumn
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_SWIPER:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={
                                                                    model?.isShowTitle === 2
                                                                        ? styles.singleVideoBg
                                                                        : styles.cardBg
                                                                }
                                                                style={getCusStyle(model)}
                                                            >
                                                                <VideoSwpier
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    bannersModel={model}
                                                                    ubcValue="jump_shipinlunbo"
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                key={model.moduleId}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SeamlessPuzzle
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    ubcValue="jump_wufengpinjie"
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                        }
                                        break;
                                    case SELF_TOPIC_TOFU_CUBE_NAME:
                                        return (
                                            model?.itemList?.length
                                                ? (
                                                    <div
                                                        id={model.moduleId?.toString()}
                                                        key={model.moduleId}
                                                        className={styles.cardBg}
                                                        style={getCusStyle(model)}
                                                    >
                                                        <SelfTopicTofuText
                                                            page={mPage}
                                                            sfRef={sfRef}
                                                            infos={model}
                                                            channelBusinessLine={cblMap[cbl]}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_CONTENT_NAME:
                                        switch (model.moduleStyle) {
                                            case SELF_TOPIC_CONTENT_TYPE_HORIZONTAL:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContentHorizontal
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContentFlowSmall
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_CONTENT_TYPE_FLOW_BIG:
                                                return (
                                                    model?.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContentFlowBig
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_CONTENT_TYPE_SINGLEABS:
                                                return (
                                                    model?.itemList && model.itemList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContentSingleAbstract
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                        }
                                        break;
                                    case SELF_TOPIC_CONTAINER:
                                        switch (model.moduleStyle) {
                                            case SELF_TOPIC_CONTAINER_TYPE_H:
                                                return (
                                                    model?.subModuleList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardContentHBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContainerHorizontal
                                                                    page={mPage}
                                                                    sfRef={sfRef}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_CONTAINER_TYPE_V:
                                                return (
                                                    model?.subModuleList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={styles.cardContentVBg}
                                                                style={getCusStyle(model)}
                                                            >
                                                                <SelfTopicContainerVertical
                                                                    page={mPage}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );
                                            case SELF_TOPIC_CONTAINER_TYPE_MIX:
                                                return (
                                                    model?.subModuleList?.length
                                                        ? (
                                                            <div
                                                                id={model.moduleId?.toString()}
                                                                key={model.moduleId}
                                                                className={
                                                                    (model.isShowTitle === 1
                                                                        && (model.moduleName || model.moduleSubTitle)
                                                                    )
                                                                        ? styles.cardBg : styles.cardBottomBg
                                                                }
                                                                style={{
                                                                    ...getCusStyle(model),
                                                                }}
                                                            >
                                                                <SelfTopicContainerAggregation
                                                                    page={mPage}
                                                                    channelBusinessLine={cblMap[cbl]}
                                                                    sfRef={sfRef}
                                                                    infos={model}
                                                                />
                                                            </div>
                                                        )
                                                        : null
                                                );

                                        }
                                        break;
                                    case SELF_TOPIC_TAB_NAME:
                                        return (
                                            model?.itemList?.length
                                                ? (
                                                    <div
                                                        id={model.moduleId?.toString()}
                                                        key={model.moduleId}
                                                        className={styles.cardBg}
                                                        style={getCusStyle(model)}
                                                    >
                                                        <SelfTopicTofuText page={mPage} sfRef={sfRef} infos={model} />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case SELF_TOPIC_EXPERT:
                                        return (
                                            model?.itemList?.length
                                                ? (
                                                    <div
                                                        id={model.moduleId?.toString()}
                                                        key={model.moduleId}
                                                        className={styles.expertCardBg}
                                                        style={getCusStyle(model)}
                                                    >
                                                        <SelfTopicExpert
                                                            page={mPage}
                                                            channelBusinessLine={cblMap[cbl]}
                                                            sfRef={sfRef}
                                                            infos={model}
                                                        />
                                                    </div>
                                                )
                                                : null
                                        );
                                    case COMMON_VOTE:
                                        return (
                                            <Vote
                                                // @ts-ignore
                                                data={model}
                                            />
                                        );
                                    case COMMON_APP_INVOKE:
                                        // eslint-disable-next-line no-case-declarations
                                        const InvokeData = model?.itemList?.[0]?.fieldValue;

                                        return isDoctorApp() ? null : (
                                            InvokeData
                                                ? (
                                                    // @ts-ignore
                                                    <AppInvoke
                                                        {...InvokeData}
                                                    />
                                                )
                                                : null
                                        );
                                }
                            }
                        )
                    }
                </div>
            );
        },
        [topicInfos, mPage, sfRef, cblMap, cbl]
    );

    // 渲染头图
    const renderTopCard = () => {
        return (
            <div
                id={'renderTopCardId'}
            >
                <DiseaseTopCard
                    infos={topCardInfo}
                    page={mPage}
                    channelBusinessLine={cblMap[cbl]}
                    channelId={channelId}
                />
            </div>
        );
    };

    const renderSlideBar = useCallback(

        () => {
            return (
                <div
                    className={styles(
                        slideBarStatus ? styles.slideParentShow : styles.slideParentHide,
                        {
                            [styles.pc]: !isWiseAgent(navigator.userAgent),
                        }
                    )}
                >
                    <SelfNaviSlideBar
                        page={mPage}
                        sfRef={sfRef}
                        show={slideBarStatus}
                        channelBusinessLine={cblMap[cbl]}
                        moduleId={selectModuleId?.toString()}
                        childModuleId={selectChildModuleId?.toString()}
                        // eslint-disable-next-line react/jsx-no-bind
                        onItemClick={
                            (moduleId, childModelId) => {
                                setSelectModuleId(moduleId);
                                setChildModuleId(childModelId);
                                // eslint-disable-next-line max-len
                                const number = (document.getElementById(moduleId)?.getBoundingClientRect().y || 0) - navHeight;
                                window.scrollBy({behavior: 'smooth', left: 0, top: number});
                            }
                        }
                        // eslint-disable-next-line react/jsx-no-bind
                        onStateChange={show => {
                            setSlideBarStatus(show);
                        }}
                        infos={slideBarInfo}
                    />
                </div>
            );
        },
        [cbl, cblMap, mPage, navHeight, selectChildModuleId, selectModuleId, sfRef, slideBarInfo, slideBarStatus]
    );

    const renderNaviH = useCallback(
        () => {
            return (
                <div
                    id={'renderNaviHId'}
                >
                    {
                        naviBarStatus
                            ? (
                                <SelfNaviH
                                    page={mPage}
                                    sfRef={sfRef}
                                    moduleId={selectModuleId?.toString()}
                                    infos={naviBarInfo}
                                    channelBusinessLine={cblMap[cbl]}
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onItemClick={(moduleId, childModelId) => {
                                        setSelectModuleId(moduleId);
                                        setChildModuleId(childModelId);
                                        // eslint-disable-next-line max-len
                                        const number = (document.getElementById(moduleId)?.getBoundingClientRect().y || 0) - navHeight;
                                        window.scrollBy({behavior: 'smooth', left: 0, top: number});
                                    }}
                                />
                            )
                            : null
                    }
                </div>
            );
        },
        [cbl, cblMap, mPage, navHeight, naviBarInfo, naviBarStatus, selectModuleId, sfRef]
    );

    const renderBottomBar = useCallback(
        () => {
            return (
                <div id="topic-bottomBar">
                    <SelfTopicBottomBar
                        page={mPage}
                        sfRef={sfRef}
                        infos={bottomBarInfo}
                        channelBusinessLine={cblMap[cbl]}
                    />
                </div>
            );
        },
        [bottomBarInfo, cbl, cblMap, mPage, sfRef]
    );

    return (
        <div
            className={styles.pageContainer}
            onClick={() => {
                // eslint-disable-next-line no-unused-expressions
                slideBarStatus ? setSlideBarStatus(false) : null;
            }}
            style={{
                backgroundColor: pageBgc,
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    width: isWiseAgent(navigator.userAgent) ? '-webkit-calc(100%)' : '640px',
                    top: 0,
                }}
                className={styles({
                    [styles.innerPC]: !isWiseAgent(navigator.userAgent),
                })}
            >
                {/* 头图 */}
                {
                    topCardInfo?.moduleId ? renderTopCard() : <div className={styles.topMargin} />
                }
                <div
                    id={'belowTopImgParentId'}
                    className={styles.bgParent}
                    style={{
                        marginBottom: bottomBarInfo?.itemList ? 60 : 0,
                        backgroundColor: pageBgc ? pageBgc : '#f5f5f5',
                    }}
                >
                    <div
                        className={styles.bgBelow}
                        style={{
                            backgroundColor: pageBgc ? pageBgc : '#f5f5f5',
                        }}
                    />
                    <div
                        className={topCardInfo?.moduleId ? styles.belowTopImgParentMargin : styles.belowTopImgParent}
                    >
                        {renderInfo()}
                    </div>
                </div>
                {
                    bottomBarInfo?.itemList ? renderBottomBar() : null
                }
            </div>
            {
                naviBarInfo?.itemList
                    ? (
                        <div
                            style={{
                                position: 'fixed',
                                width: '-webkit-calc(100%)',
                                top: 0,
                            }}
                        >
                            {
                                renderNaviH()
                            }
                        </div>
                    )
                    : null
            }

            {
                slideBarInfo?.itemList
                    ? (
                        <div
                            style={{
                                position: 'fixed',
                                width: '-webkit-calc(100%)',
                                top: 0,
                            }}
                        >
                            {
                                renderSlideBar()
                            }
                        </div>
                    )
                    : null
            }
            {
                entryBallInfo
                && entryBallInfo.itemList
                && entryBallInfo.itemList.length > 0
                    ? <BrandEntry info={entryBallInfo} channelBusinessLine={cblMap[cbl]} page={mPage} />
                    : null
            }
        </div>
    );
};

export default SpecialDisease;
